import { render, staticRenderFns } from "./AwaitTillDate.vue?vue&type=template&id=92fff0d6&"
import script from "./AwaitTillDate.vue?vue&type=script&lang=js&"
export * from "./AwaitTillDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports